import { render, staticRenderFns } from "./UploadRecursoDlg.vue?vue&type=template&id=6a1887c4"
import script from "./UploadRecursoDlg.vue?vue&type=script&lang=js"
export * from "./UploadRecursoDlg.vue?vue&type=script&lang=js"
import style0 from "./UploadRecursoDlg.vue?vue&type=style&index=0&id=6a1887c4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports